import React from 'react';

export const ThemeContext = React.createContext<{
  theme: 'light' | 'dark';
  toggleScheme?: () => void;
}>({
  theme: 'light',
});
